import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  FaUsers,
  FaMapMarkerAlt,
  FaHandshake,
  FaCheckCircle,
  FaDollarSign,
  FaArrowUp,
  FaBriefcase,
  FaStar,
  FaInstagram,
  FaFacebook,
  FaUserTie,
  FaBolt,
  FaHardHat,
  FaBuilding,
  FaRocket,
  FaShieldAlt,
  FaChevronRight,
} from "react-icons/fa";
import axiosInstance from "../axiosInstance";
import main from "../images/main3.png";
import HowItWorks from "../components/HowItWorks";
import AnimatedUserCount from "../components/AnimatedUserCount ";
import ScrollingUsers from "../components/Home/ScrollingUsers";
import skilledmatesgif from "../images/skilledmates.gif";

// Reusable animation variants
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.6, ease: "easeOut" },
  }),
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: (i = 0) => ({
    opacity: 1,
    scale: 1,
    transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" },
  }),
};

const HomePage = () => {
  const navigate = useNavigate();
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [news, setNews] = useState([]);
  const [progressWidth, setProgressWidth] = useState(0);
  const progressDuration = 7000;
  const [showButton, setShowButton] = useState(false);
  const [newUsers, setNewUsers] = useState([]);
  const [newUsersImages, setNewUsersImages] = useState([]);
  const [visibleImages, setVisibleImages] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0); // eslint-disable-line
  const [RandonNumber, setRandonNumber] = useState(0);

  const SMALL_MEMBERSHIP_FEE = Number(
    process.env.REACT_APP_SMALL_MEMBERSHIP_FEE || 10
  );
  const LARGE_MEMBERSHIP_FEE = Number(
    process.env.REACT_APP_LARGE_MEMBERSHIP_FEE || 25
  );

  // const sponsors = [
  //   {
  //     id: 1,
  //     name: "Entry Education",
  //     logo: "https://entryeducation.edu.au/wp-content/uploads/2021/05/entry-education250x97px.png", // Replace with sponsor logo URL
  //     description:
  //       "Enrol and study your real estate course online or your finance and mortgage broking course without mountains of paperwork, stress or unachievable deadlines.",
  //     website: "https://entryeducation.edu.au/",
  //   },
  //   {
  //     id: 2,
  //     name: "LJ Hooker ",
  //     logo: "https://ljh-public.s3.amazonaws.com/ljh-logo-black_152x30.svg",
  //     description: "Real estate agents in Adelaide Metro.",
  //     website: "https://stpeters.ljhooker.com.au/",
  //   },
  //   {
  //     id: 3,
  //     name: "Raywhite ",
  //     logo: "https://au.cdn.realty.com.au/agency/5CU9POlc1",
  //     description:
  //       "Join Australia's leading real estate group, with nearly 12,000 property professionals and 1,000 businesses across 11 countries.",
  //     website: "https://www.raywhite.com/",
  //   },
  // ];

  const sponsors = [
    {
      id: 1,
      name: "Entry Education",
      logo: "https://entryeducation.edu.au/wp-content/uploads/2021/05/entry-education250x97px.png", // Replace with sponsor logo URL
      description:
        "Enrol and study your real estate course online or your finance and mortgage broking course without mountains of paperwork, stress or unachievable deadlines.",
      website: "https://entryeducation.edu.au/",
    },
    {
      id: 2,
      name: "RAA",
      logo: "https://our.raa.com.au/assets/images/raa-logo.png",
      description:
        "RAA is a trusted member-based organisation providing roadside assistance, insurance, travel, and mobility services. With a strong focus on safety, value, and community, RAA supports South Australians at every stage of their journey.",
      website: "https://www.raa.com.au/",
      phone: "0882024600",
    },
    {
      id: 3,
      name: "Virginia Nursery ",
      logo: "https://www.virginianursery.com.au/shop_image/vendor/ac1f35aa6a62f8af1465dfd9a0b63d58.jpg",
      description:
        "Adelaide's largest retail garden centres, with an unrivalled selection of plants and trees. Expert advice and quality products for all your gardening needs.",
      website: "https://www.virginianursery.com.au/",
      phone: "0883076800",
    },
  ];

  //Generate random number between 50-200

  useEffect(() => {
    setRandonNumber(Math.floor(Math.random() * (200 - 50 + 1)) + 50);
  }, []);

  useEffect(() => {
    const fetchNewUsersImages = async () => {
      try {
        const response = await axiosInstance.get("/api/getNewUsersImages");
        const imgs = response.data.usersImages;
        setNewUsersImages(imgs);
        setVisibleImages(imgs.slice(0, 5));
        setTotalUsers(response.data.totalUsers);
      } catch (error) {
        console.error("Error fetching new users images:", error);
      }
    };

    fetchNewUsersImages();
  }, []);

  // Rotate visible avatars every 3 seconds
  useEffect(() => {
    if (newUsersImages.length <= 5) return;
    let offset = 0;
    const interval = setInterval(() => {
      offset = (offset + 1) % newUsersImages.length;
      const rotated = [];
      for (let i = 0; i < 5; i++) {
        rotated.push(newUsersImages[(offset + i) % newUsersImages.length]);
      }
      setVisibleImages(rotated);
    }, 3000);
    return () => clearInterval(interval);
  }, [newUsersImages]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axiosInstance.get("/api/news");
        setNews(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews();
  }, []);

  useEffect(() => {
    const fetchNewUsers = async () => {
      try {
        const response = await axiosInstance.get("/api/newusers");
        setNewUsers(response.data);
      } catch (error) {
        console.error("Error fetching new users:", error);
      }
    };

    fetchNewUsers();
  }, []);

  useEffect(() => {
    const fetchVisitorCount = async () => {
      try {
        await axiosInstance.get("/api/visitorcount");
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    };

    fetchVisitorCount();
  }, []);

  useEffect(() => {
    // Reset progress bar when news or currentCardIndex changes
    setProgressWidth(0);
    const interval = setInterval(() => {
      setProgressWidth((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          handleNextNews();
          return 100;
        }
        return prevProgress + 1;
      });
    }, progressDuration / 100);

    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [news, currentCardIndex]);

  const handleNextNews = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex + 1) % news.length);
  };

  const handleFindWorkClick = () => {
    navigate("/find-work");
  };

  const handleFindWorkerClick = () => {
    navigate("/find-worker");
  };

  // Detect scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const testimonials = [
    {
      name: "John Doe",
      message:
        "Skilled Mates helped me land a job within days! The opportunities matched my skills perfectly. Highly recommend for anyone looking for flexible work.",
      rating: 5,
    },
    {
      name: "Jane Smith",
      message:
        "Finding reliable staff on short notice used to be stressful. Skilled Mates made it easy and fast — the platform is super user-friendly and efficient.",
      rating: 4,
    },
    {
      name: "Robert Brown",
      message:
        "Thanks to Skilled Mates, I found extra shifts nearby that fit my schedule perfectly. It’s been a great way to earn extra income on my own terms.",
      rating: 5,
    },
    {
      name: "Emily Johnson",
      message:
        "As a small business owner, Skilled Mates helped me avoid staffing headaches and connect with great workers quickly. Love the affordable membership plans!",
      rating: 5,
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Change testimonials every 5 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div className="bg-white overflow-x-hidden">
      {/* Scroll-to-top button */}
      <AnimatePresence>
        {showButton && (
          <motion.button
            key="scrolltop"
            onClick={scrollToTop}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            whileHover={{ scale: 1.15 }}
            className="fixed bottom-6 right-6 z-50 p-3 rounded-full shadow-xl text-white"
            style={{ background: "linear-gradient(135deg, #6A5ACD, #00BFFF)" }}
          >
            <FaArrowUp size={18} />
          </motion.button>
        )}
      </AnimatePresence>

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="relative flex flex-col items-center justify-center overflow-hidden py-8 px-4 bg-gradient-to-br from-blue-50 via-white to-indigo-50">
        {/* Decorative blobjs */}
        <div
          className="pointer-events-none absolute -top-24 -left-24 w-80 h-80 rounded-full opacity-30"
          style={{ background: "radial-gradient(circle, #6A5ACD55, transparent)" }}
        />
        <div
          className="pointer-events-none absolute -bottom-16 -right-16 w-72 h-72 rounded-full opacity-20"
          style={{ background: "radial-gradient(circle, #00BFFF44, transparent)" }}
        />

        {/* Hero image with split clickable zones */}
        <div className="relative flex justify-center items-center w-full max-w-2xl mx-auto">
          <div className="absolute inset-0 flex z-10">
            <div
              onClick={handleFindWorkClick}
              className="w-1/2 h-full cursor-pointer"
              title="Find Work"
            />
            <div
              onClick={handleFindWorkerClick}
              className="w-1/2 h-full cursor-pointer"
              title="Find Workers"
            />
          </div>
          <motion.img
            src={main}
            alt="Skilled Mates"
            className="w-full h-auto max-h-96 md:max-h-[520px] lg:max-h-[640px] object-contain drop-shadow-2xl"
            initial={{ opacity: 0, scale: 0.85, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          />
        </div>

        {/* Headline */}
        <motion.h1
          style={{ fontFamily: "'Poppins', sans-serif" }}
          className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 text-center mt-6 mb-3 leading-tight"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          Find Casual Shifts &amp; Workers
          <br />
          <span className="relative inline-block mt-1">
            <span className="relative z-10 text-transparent bg-clip-text" style={{ backgroundImage: "linear-gradient(90deg,#6A5ACD,#00BFFF)" }}>
              Instantly. Locally.
            </span>
            <span className="absolute inset-x-0 -bottom-1 h-2 rounded-full opacity-40" style={{ background: "linear-gradient(90deg,#6A5ACD,#00BFFF)" }} />
          </span>
        </motion.h1>

        {/* Sub-cards */}
        <motion.div
          className="w-full max-w-2xl grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6 mb-4 px-2"
          initial="hidden"
          animate="visible"
          variants={{ visible: { transition: { staggerChildren: 0.12 } } }}
        >
          {[
            { emoji: "👷‍♂️", title: "For Workers", text: "Pick up casual shifts that fit your schedule and earn on your own terms.", color: "from-blue-500 to-indigo-500" },
            { emoji: "🧑‍💼", title: "For Employers", text: "Post a casual shift and find reliable workers nearby — fast and hassle-free.", color: "from-emerald-500 to-teal-500" },
          ].map((card) => (
            <motion.div
              key={card.title}
              variants={fadeUp}
              className="relative p-5 bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden"
            >
              <div className={`absolute top-0 left-0 w-1 h-full rounded-l-2xl bg-gradient-to-b ${card.color}`} />
              <div className="pl-3">
                <motion.span
                  className="text-3xl block mb-2"
                  animate={{ y: [0, -6, 0] }}
                  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
                >
                  {card.emoji}
                </motion.span>
                <h3 className="text-lg font-bold text-gray-800 mb-1">{card.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{card.text}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA buttons */}
        <motion.div
          className="flex flex-col sm:flex-row gap-3 mt-2 mb-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={handleFindWorkClick}
            className="px-8 py-3 rounded-full font-bold text-white shadow-lg text-base"
            style={{ background: "linear-gradient(135deg,#6A5ACD,#4F46E5)" }}
          >
            Find Work
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={handleFindWorkerClick}
            className="px-8 py-3 rounded-full font-bold text-white shadow-lg text-base"
            style={{ background: "linear-gradient(135deg,#10B981,#059669)" }}
          >
            Find Workers
          </motion.button>
        </motion.div>

        {/* Scrolling users */}
        {newUsers.length > 0 && <ScrollingUsers newUsers={newUsers} />}

        {/* HowItWorks */}
        <HowItWorks />

        {/* Live user count */}
        <div className="mt-4 mb-6">
          {newUsersImages.length > 0 ? (
            <motion.div
              className="flex flex-col items-center gap-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
            >
              <div className="flex -space-x-3">
                {visibleImages.map((user, index) => (
                  <motion.div
                    key={user.profileImage + index}
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.4, delay: 0.06 * index }}
                    className="w-14 h-14 rounded-full border-2 border-white overflow-hidden shadow"
                  >
                    <img alt="User" className="w-full h-full object-cover" src={user.profileImage} />
                  </motion.div>
                ))}
              </div>
              <p className="text-gray-600 font-semibold text-sm flex items-center gap-2">
                <AnimatedUserCount initialNumber={RandonNumber} />
                <span>users active now</span>
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                  <span className="relative inline-flex h-3 w-3 rounded-full bg-green-500" />
                </span>
              </p>
            </motion.div>
          ) : (
            <div className="flex justify-center items-center h-20">
              <div className="w-10 h-10 rounded-full border-4 border-indigo-200 border-t-indigo-500 animate-spin" />
            </div>
          )}
        </div>
      </section>

      {/* ── WHAT'S NEW ───────────────────────────────────────── */}
      {news.length > 0 && (
        <section className="py-14 bg-white">
          <div className="max-w-2xl mx-auto px-4 text-center">
            <motion.h2
              className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              What's New on Skilled Mates
            </motion.h2>
            <AnimatePresence mode="wait">
              <motion.div
                key={currentCardIndex}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -30 }}
                transition={{ duration: 0.4 }}
                onClick={() => {
                  const target = news[currentCardIndex]?.takeUserTo;
                  if (target) window.location.href = target;
                }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter") window.location.href = news[currentCardIndex]?.takeUserTo; }}
                className="cursor-pointer rounded-2xl shadow-md bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 p-6 hover:shadow-xl transition-shadow"
              >
                <h3 className="text-lg font-semibold text-gray-800 mb-3">{news[currentCardIndex]?.description}</h3>
                <div className="flex items-center justify-center gap-2 text-blue-500 text-sm mb-5">
                  <FaMapMarkerAlt size={14} />
                  <span>{news[currentCardIndex].location}</span>
                </div>
                <div className="w-full h-1.5 bg-blue-100 rounded-full overflow-hidden">
                  <motion.div
                    className="h-1.5 rounded-full"
                    style={{ background: "linear-gradient(90deg,#6A5ACD,#00BFFF)", width: `${progressWidth}%` }}
                    transition={{ duration: 0.3 }}
                  />
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </section>
      )}

      {/* ── PRICING ──────────────────────────────────────────── */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <motion.h2
            className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Simple, Transparent Pricing
          </motion.h2>
          <motion.p
            className="text-gray-500 max-w-xl mx-auto mb-12 text-base"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15, duration: 0.5 }}
          >
            Affordable plans for job seekers and employers of every size.
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: <FaHardHat className="text-blue-500 text-5xl mx-auto mb-4" />,
                title: "For Workers",
                subtitle: "Always free",
                price: "Free",
                priceNote: "Forever",
                features: ["Create your profile", "Browse all job listings", "Apply to unlimited jobs", "No hidden fees"],
                cta: "Get Started Free",
                ctaColor: "from-blue-500 to-indigo-600",
                borderColor: "border-blue-300",
                highlight: false,
              },
              {
                icon: <FaBuilding className="text-emerald-500 text-5xl mx-auto mb-4" />,
                title: "Small–Mid Employer",
                subtitle: "Perfect for cafes, NDIS, cleaners",
                price: `$${SMALL_MEMBERSHIP_FEE}`,
                priceNote: "/ month",
                features: ["Post unlimited jobs", "Contact 70 workers/week", "Worker profile browsing", "Email support"],
                cta: "Get Membership",
                ctaColor: "from-emerald-500 to-teal-600",
                borderColor: "border-emerald-300",
                highlight: true,
              },
              {
                icon: <FaRocket className="text-yellow-500 text-5xl mx-auto mb-4" />,
                title: "Large Employer",
                subtitle: "For recruitment & factories",
                price: `$${LARGE_MEMBERSHIP_FEE}`,
                priceNote: "/ month",
                features: ["Post unlimited jobs", "Contact unlimited workers", "Priority support", "Advanced search filters"],
                cta: "Get Membership",
                ctaColor: "from-yellow-400 to-orange-500",
                borderColor: "border-yellow-300",
                highlight: false,
              },
            ].map((plan, i) => (
              <motion.div
                key={plan.title}
                custom={i}
                variants={scaleIn}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                whileHover={{ y: -6, boxShadow: "0 20px 40px -12px rgba(0,0,0,0.15)" }}
                onClick={() => navigate("/register")}
                className={`relative cursor-pointer bg-white rounded-2xl p-8 border-2 ${plan.borderColor} transition-all duration-300 ${plan.highlight ? "ring-2 ring-emerald-400 ring-offset-2" : ""}`}
              >
                {plan.highlight && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-emerald-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow">
                    Most Popular
                  </div>
                )}
                {plan.icon}
                <h3 className="text-xl font-bold text-gray-900 mb-1">{plan.title}</h3>
                <p className="text-gray-400 text-sm mb-4">{plan.subtitle}</p>
                <div className="mb-6">
                  <span className="text-4xl font-extrabold text-gray-900">{plan.price}</span>
                  <span className="text-gray-400 text-sm ml-1">{plan.priceNote}</span>
                </div>
                <ul className="space-y-2 text-sm text-left mb-8">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-gray-600">
                      <FaCheckCircle className="text-green-500 flex-shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <motion.button
                  whileHover={{ scale: 1.04 }}
                  whileTap={{ scale: 0.97 }}
                  className={`w-full py-3 rounded-full font-bold text-white bg-gradient-to-r ${plan.ctaColor} shadow-md`}
                >
                  {plan.cta}
                </motion.button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── GIF DEMO ─────────────────────────────────────────── */}
      <section className="py-14 bg-white flex flex-col items-center px-4">
        <motion.h2
          className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          See How It Works
        </motion.h2>
        <motion.div
          className="w-full max-w-3xl rounded-2xl overflow-hidden shadow-2xl"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <img
            src={skilledmatesgif}
            alt="How to find worker animation"
            className="w-full h-auto object-contain"
          />
        </motion.div>
      </section>

      {/* ── WHY CHOOSE US ────────────────────────────────────── */}
      <section className="py-20 bg-gradient-to-br from-indigo-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <motion.h2
            className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Why Choose Skilled Mates?
          </motion.h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: <FaUserTie className="text-purple-500 text-4xl" />, title: "Be Your Own Boss", text: "Work when you want, where you want — no middlemen, no commissions.", bg: "from-purple-50 to-indigo-50", border: "border-purple-200" },
              { icon: <FaUsers className="text-blue-500 text-4xl" />, title: "No More Staff Shortages", text: "Access a large pool of skilled workers instantly whenever you need them.", bg: "from-blue-50 to-sky-50", border: "border-blue-200" },
              { icon: <FaDollarSign className="text-yellow-500 text-4xl" />, title: "Affordable Memberships", text: "The lowest-cost platform for employers — transparent, no surprise charges.", bg: "from-yellow-50 to-amber-50", border: "border-yellow-200" },
              { icon: <FaHandshake className="text-green-500 text-4xl" />, title: "Quick Connections", text: "Match with the right person within minutes using our smart search tools.", bg: "from-green-50 to-emerald-50", border: "border-green-200" },
              { icon: <FaMapMarkerAlt className="text-red-500 text-4xl" />, title: "Location-Based Search", text: "Find work or workers near you — local connections made simple.", bg: "from-red-50 to-rose-50", border: "border-red-200" },
              { icon: <FaShieldAlt className="text-indigo-500 text-4xl" />, title: "Safe & Trusted", text: "A verified community of workers and employers with ratings and reviews.", bg: "from-indigo-50 to-violet-50", border: "border-indigo-200" },
            ].map((feat, i) => (
              <motion.div
                key={feat.title}
                custom={i}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                whileHover={{ y: -5, boxShadow: "0 16px 32px -8px rgba(0,0,0,0.1)" }}
                className={`bg-gradient-to-br ${feat.bg} border ${feat.border} p-6 rounded-2xl transition-all duration-300`}
              >
                <div className="mb-4 flex justify-center">{feat.icon}</div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{feat.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{feat.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SPONSORS ─────────────────────────────────────────── */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <motion.h2
            className="text-3xl font-bold text-gray-900 text-center mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Our Sponsors
          </motion.h2>
          <p className="text-center text-gray-400 mb-10 text-sm">Support our featured businesses and discover great services!</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {sponsors.map((sponsor, i) => (
              <motion.div
                key={sponsor.id}
                custom={i}
                variants={scaleIn}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                whileHover={{ y: -4 }}
                className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-xl"
              >
                <div className="h-32 flex items-center justify-center bg-gray-50 p-4">
                  <img src={sponsor.logo} alt={sponsor.name} className="max-h-full max-w-full object-contain" />
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-gray-800 mb-1">{sponsor.name}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed mb-4">{sponsor.description}</p>
                  <div className="flex gap-2 flex-wrap">
                    <a
                      href={sponsor.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs font-semibold px-4 py-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                    >
                      Visit Website
                    </a>
                    {sponsor.phone && (
                      <a
                        href={`tel:${sponsor.phone}`}
                        className="text-xs font-semibold px-4 py-2 rounded-full bg-orange-500 text-white hover:bg-orange-600 transition-colors"
                      >
                        Call
                      </a>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          <div className="mt-10 text-center">
            <p className="text-gray-500 text-sm mb-3">Want to be our sponsor? Fill out the feedback form!</p>
            <motion.a
              whileHover={{ scale: 1.05 }}
              href="/feedback"
              className="inline-block px-6 py-2.5 rounded-full bg-gradient-to-r from-green-500 to-teal-500 text-white font-semibold text-sm shadow hover:shadow-md transition-all"
            >
              Become a Sponsor
            </motion.a>
          </div>
        </div>
      </section>

      {/* ── REFERRAL ─────────────────────────────────────────── */}
      {/* <section className="py-16 bg-gradient-to-br from-green-50 to-teal-50 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2
            className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            💸 Earn up to $50 — Referral Program
          </motion.h2>
          <p className="text-gray-600 mb-8 text-base leading-relaxed">
            Refer an employer who buys a membership, and earn up to $50. It's that simple.
          </p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15, duration: 0.6 }}
            className="bg-gradient-to-r from-green-500 to-teal-500 text-white p-8 rounded-2xl shadow-xl text-left space-y-4"
          >
            {[
              "Get someone to sign up as an employer on Skilled Mates.",
              "Ensure they purchase a Skilled Mates Membership.",
              <>Fill out our <a href="https://www.skilledmates.com.au/feedback" target="_blank" rel="noopener noreferrer" className="underline hover:text-yellow-200">feedback form</a> with the employer's email and your contact details.</>,
            ].map((step, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="w-7 h-7 flex-shrink-0 rounded-full bg-white text-green-600 font-extrabold text-sm flex items-center justify-center shadow">
                  {i + 1}
                </span>
                <p className="text-sm leading-relaxed">{step}</p>
              </div>
            ))}
          </motion.div>
          <p className="text-gray-400 text-xs mt-6">
            Terms: Employer must maintain membership for at least one month to qualify for the reward.
          </p>
        </div>
      </section> */}

      {/* ── COMMUNITY CTA ────────────────────────────────────── */}
      {/* <section className="py-20 bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <motion.h2
            className="text-3xl sm:text-4xl font-extrabold mb-4 leading-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Join the <span className="text-yellow-300">Growing Community</span>
          </motion.h2>
          <motion.p
            className="text-blue-100 mb-12 max-w-2xl mx-auto text-base leading-relaxed"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15, duration: 0.5 }}
          >
            Skilled Mates is expanding fast. Join today to find your next opportunity or the perfect candidate.
          </motion.p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12">
            {[
              { icon: <FaUserTie className="text-yellow-300 text-3xl mx-auto mb-3" />, title: "For Workers", text: "Choose jobs that fit your schedule and earn on your terms." },
              { icon: <FaBriefcase className="text-green-300 text-3xl mx-auto mb-3" />, title: "For Employers", text: "Never worry about staff shortages. Find skilled workers fast." },
              { icon: <FaBolt className="text-pink-300 text-3xl mx-auto mb-3" />, title: "Instant Matches", text: "Get matched in real-time so you never miss an opportunity." },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                custom={i}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 hover:bg-white/20 transition-colors"
              >
                {item.icon}
                <h3 className="font-bold text-lg mb-1">{item.title}</h3>
                <p className="text-blue-100 text-sm leading-relaxed">{item.text}</p>
              </motion.div>
            ))}
          </div>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate("/register")}
            className="px-10 py-4 rounded-full font-bold text-blue-700 bg-white shadow-xl text-lg hover:bg-yellow-50 transition-colors"
          >
            Sign Up Today — It's Free!
          </motion.button>
        </div>
      </section> */}

      {/* ── TESTIMONIALS ─────────────────────────────────────── */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <motion.h2
            className="text-3xl font-bold text-gray-900 mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            What Our Users Say
          </motion.h2>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentTestimonialIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              className="bg-gradient-to-br from-indigo-50 to-blue-50 p-8 rounded-2xl shadow-md border border-indigo-100"
            >
              <div className="flex justify-center mb-4">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    className={index < testimonials[currentTestimonialIndex].rating ? "text-yellow-400" : "text-gray-200"}
                    size={20}
                  />
                ))}
              </div>
              <p className="text-gray-700 text-lg italic mb-5 leading-relaxed">
                "{testimonials[currentTestimonialIndex].message}"
              </p>
              <p className="font-bold text-gray-900">— {testimonials[currentTestimonialIndex].name}</p>
            </motion.div>
          </AnimatePresence>
          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentTestimonialIndex(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === currentTestimonialIndex ? "bg-indigo-500 w-6" : "bg-gray-300"}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ── CONTACT ──────────────────────────────────────────── */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.h2
            className="text-3xl font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Get in Touch
          </motion.h2>
          <p className="text-gray-400 mb-6">Have questions? We'd love to hear from you.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10">
            <motion.div whileHover={{ scale: 1.05 }}>
              <Link
                to="/feedback"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-indigo-600 hover:bg-indigo-700 font-semibold text-sm transition-colors shadow"
              >
                <FaChevronRight size={12} /> Message Us
              </Link>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }}>
              <a
                href="mailto:sukhi@skilledmates.com.au"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 font-semibold text-sm transition-colors border border-white/20"
              >
                Email Us
              </a>
            </motion.div>
          </div>
          <p className="text-gray-400 text-sm mb-4 font-semibold uppercase tracking-wide">Follow Us</p>
          <div className="flex justify-center gap-6">
            <motion.a
              whileHover={{ scale: 1.2 }}
              href="https://www.facebook.com/profile.php?id=61565426317581"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors font-semibold"
            >
              <FaFacebook size={22} /> Facebook
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.2 }}
              href="https://www.instagram.com/skilledmates.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-pink-400 hover:text-pink-300 transition-colors font-semibold"
            >
              <FaInstagram size={22} /> Instagram
            </motion.a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
